import { window } from "@swa-ui/browser/window";
import { getItem, setItem } from "@swa-ui/persistence/persistence";

const CAR_PERSISTENCE_DATA_KEY = "carPersistedDataStorage";
const CAR_PERSISTENCE_TIME_TO_LIVE_IN_MINUTES = 30;

export const getPersistedCarData = () => {
  const carPersistenceData = getItem(CAR_PERSISTENCE_DATA_KEY, {});

  return carPersistenceData?.value;
};

export const setPersistedCarData = (carData) => {
  setItem(CAR_PERSISTENCE_DATA_KEY, carData, {
    timeToLiveInMinutes: CAR_PERSISTENCE_TIME_TO_LIVE_IN_MINUTES,
  });
};

export const resetPersistedCarData = () => {
  window.sessionStorage.removeItem(CAR_PERSISTENCE_DATA_KEY);
};
